import AppointmentDto from './AppointmentDto';

export default class SuccessListEntryHistory extends AppointmentDto {
    public readonly isOnline: boolean;

    constructor(json: any) {
        super(json);
        this.isOnline = json.isOnline;
    }
}
